import Vue from 'vue'
import Vuex from 'vuex'
import global from '@/store/global'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: global.state,
  getters: global.getters,
  mutations: global.mutations,
  actions: global.actions,
  modules: {
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js